<script lang="ts">
	import { onMount } from "svelte";
	import Box from "./Box.svelte";
	export let data;

	export let network;

	let dataNodes = [];

	console.log("Here", data.nodes.get());
	dataNodes = data.nodes.get();

	// subscribe to any change in the DataSet
	data.nodes.on("*", function (event, properties, senderId) {
		console.log("event:", event, "properties:", properties, "senderId:", senderId);
		dataNodes = data.nodes.get();
	});
	network.on("selectNode", (data, data2, data3) => {
		console.log("Clicked");
		console.log("Selected node", data.nodes[0]);
		// document.getElementById(`editor-${data.nodes[0]}`).scrollIntoView();
		var scrollDiv = document.getElementById(`node-${data.nodes[0]}`).offsetTop;
		var myscroll = document.getElementById(`myscroll`);
		document.getElementById(`node-${data.nodes[0]}`).children[0].click();
		myscroll.scrollTo({ top: scrollDiv, behavior: "smooth" });
	});

	// network.on("click", function (params) {
	// 	if (params.nodes.length == 0 && params.edges.length == 0) {
	// 	var updatedIds = data.nodes.add([
	// 		{
	// 			label: "new",
	// 			x: params.pointer.canvas.x,
	// 			y: params.pointer.canvas.y
	// 		}
	// 	]);
	// 	network.selectNodes([updatedIds[0]]);
	// }
	// });

	function addNew() {
		var updatedIds = data.nodes.add([
			{
				label: "new",
				x: 0,
				y: 0
			}
		]);
		network.selectNodes([updatedIds[0]]);
	}
</script>

<div class="editor" id="myscroll">
	<h1>Node Editor <span on:click={addNew}>+</span></h1>
	<div>
		{#each dataNodes as node}
			<Box {data} {network} {node} />
		{:else}
			<p>loading...</p>
		{/each}
	</div>
</div>

<style>
	.editor h1 {
		text-align: center;
		font-size: 48px;
		background: rgba(62, 62, 62, 0.9);
	}

	.editor {
		position: absolute;
		top: 0;
		right: 0;
		height: 100vh;
		width: 300px;
		background: rgba(62, 62, 62, 0.9);
		color: white;
		overflow: auto;
	}
	.editor h1 span {
		position: absolute;
		top: 2px;
		right: 5px;
		display: flex;
		border: 1px solid aqua;
		background: red;
		border-radius: 100px;
		height: 35px;
		line-height: 23px;
	}
</style>
